/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import i18next from 'i18next';
import '../styles/EditCharacter.css';
import CharacterContext from '../context/CharacterContext';
import UserContext from '../context/UserContext';
import CampaignContext from '../context/CampaignContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../components/Breadcrumb';
import CheckboxSwitch from '../components/CheckboxSwitch';
import FrameSelector from '../components/FrameSelector';
import alchemy from '../assets/alchemy.json';
import cards from '../assets/cards.json';
import {generateUpdateHisto} from '../utils/dice';
import ConfirmModal from '../components/ConfirmModal';
import { AnnotationIcon } from '@heroicons/react/solid';
import { useHistory } from 'react-router-dom';
import { calculStat } from '../utils/characterGeneration';
import dataCharacter from '../assets/dataCharacter.json';

const db = firebase.firestore();

const EditCard = ({ title, children }) => (
  <div className="editCard">
    {title && <h2 className="editCardTitle">{title}</h2>}
    <div className="editCardBody">{children}</div>
  </div>
);

const EditRow = ({ label, children }) => (
  <div className="editRow">
    <span className="editRowLabel">{label}</span>
    <div className="editRowControl">{children}</div>
  </div>
);

const EditCharacter = (props) => {
  const {user} = useContext(UserContext);
  const {character} = useContext(CharacterContext);
  const {campaign} = useContext(CampaignContext);
  const [duplicateCharacter, setDuplicateCharacter] = useState({...character});
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState("");
  const [frame, setFrame] = useState(character.framePicture || null);
  const [confirmArchiveOpen, setConfirmArchiveOpen] = useState(false);
  const [confirmRecalcOpen, setConfirmRecalcOpen] = useState(false);
  const [newUserEmail, setNewUserEmail] = useState(null);
  const [openSkillNoteIndex, setOpenSkillNoteIndex] = useState(null);
  const history = useHistory();

  useEffect(() => {
    setDuplicateCharacter(JSON.parse(JSON.stringify({...character})))
  }, [character]);

  useEffect(() => {
    duplicateCharacter.picture = url;
    if(duplicateCharacter.maxHp !== '' && duplicateCharacter.currentHp !== '' && url) {
      props.updateDataCharacter(duplicateCharacter);
      toast.success(i18next.t('update succed'), {});
    }
  }, [url]);

  const handleChange = e => {
    if (e.target.files[0]) setImage(e.target.files[0]);
  };

  const handleUpload = async () => {
    if(image.size < 800000){
      const uploadTask = firebase.storage().ref(`charactersPictures/${character.uid}.png`).put(image);
      uploadTask.on("state_changed", null, console.log, async () => {
        await firebase.storage().ref("charactersPictures").child(`${character.uid}.png`).getDownloadURL().then(url => setUrl(url));
      });
    } else {
      toast.error(i18next.t('imageToBig'), {});
    }
  };

  const saveCharacter = () => {
    duplicateCharacter.framePicture = frame === '' ? null : frame;
    duplicateCharacter.skills = duplicateCharacter.skills.filter((skill) => (skill.label !== '' && skill.value !== ''))
    if(duplicateCharacter.maxHp !== '' && duplicateCharacter.currentHp !== '') {
      if(duplicateCharacter.isAlchemist && !duplicateCharacter.inventory.find((item) => item.name === 'bottle' && item.default)) {
        duplicateCharacter.inventory.push({ default: true, name: "bottle", number: 0, type: "alchemy" });
      }
      props.updateDataCharacter(duplicateCharacter, generateUpdateHisto(duplicateCharacter, character, campaign, user));
      toast.success(i18next.t('update succed'), {});
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(image) {
      try { await handleUpload(); saveCharacter(); } catch(error) { console.log(error); }
    } else {
      saveCharacter();
    }
  };

  const recalcSkillsFromCharacs = () => {
    const updatedSkills = duplicateCharacter.skills.map(skill => {
      if (skill.isCustom || skill.isSpecial) return skill;
      const template = dataCharacter.skills.find(s => s.label === skill.label);
      if (!template) return skill;
      const c1 = duplicateCharacter.characteristics.find(c => c.label === template.stat1);
      const c2 = duplicateCharacter.characteristics.find(c => c.label === template.stat2);
      if (!c1 || !c2) return skill;
      return { ...skill, value: calculStat(c1.value, c2.value, true) };
    });
    duplicateCharacter.skills = updatedSkills;
    setDuplicateCharacter({...duplicateCharacter});
  };

  const setNewUser = async () => {
    await db.collection('users').where('email', '==', newUserEmail).get()
      .then(querySnapshot => {
        if(querySnapshot.size) {
          querySnapshot.forEach(doc => {
            if(window.confirm(`${i18next.t('assignUser.confirm')} ${doc.data().name} ?`)) {
              duplicateCharacter.idUser = doc.data().uid;
              props.updateDataCharacter(duplicateCharacter);
              toast.success(i18next.t('assignUser.succed'), {});
              setNewUserEmail('');
            }
          });
        } else {
          toast.error(i18next.t('assignUser.noUserFound'), {});
        }
      })
      .catch(err => { toast.success(i18next.t('errorApi'), {}); console.log(err); });
  };

  if (!duplicateCharacter) return null;

  return (
    <div className='editContainer'>
      <div className="editHeader">
        <button className="editBackBtn" onClick={() => history.goBack()}>
          ← {i18next.t('back')}
        </button>
        <span className="editHeaderTitle">{character.name}</span>
        <button className="editSaveBtn" onClick={handleSubmit}>
          {i18next.t('save')}
        </button>
      </div>

      <form onSubmit={handleSubmit}>

        <EditCard title={i18next.t('avatar')}>
          <div className='containerPicture'>
            <label>
              <input type="file" name="file" id="file" className="inputfile" onChange={handleChange} />
              <label htmlFor="file">{image ? image.name : i18next.t('choose a file')}</label>
            </label>
          </div>
          <FrameSelector user={user} selected={frame} select={(f) => setFrame(f)} />
        </EditCard>

        <EditCard title={i18next.t('general')}>
          <EditRow label={i18next.t('hp')}>
            <input
              name="hp" type="number" min={0} max={90}
              value={duplicateCharacter.currentHp}
              onChange={(e) => {
                duplicateCharacter.currentHp = e.target.value ? parseInt(e.target.value) : "";
                setDuplicateCharacter({...duplicateCharacter});
              }}
            />
          </EditRow>
          <div className="editDivider" />
          <EditRow label={i18next.t('hp max')}>
            <input
              name="maxHp" type="number" min={0} max={90}
              value={duplicateCharacter.maxHp}
              onChange={(e) => {
                duplicateCharacter.maxHp = e.target.value ? parseInt(e.target.value) : "";
                setDuplicateCharacter({...duplicateCharacter});
              }}
            />
          </EditRow>
          <div className="editDivider" />
          <textarea
            placeholder={i18next.t('description')}
            className='textAreaDescription'
            name="description"
            value={duplicateCharacter.description}
            onChange={(e) => {
              duplicateCharacter.description = e.target.value;
              setDuplicateCharacter({...duplicateCharacter});
            }}
          />
          <div className="editSwitches">
            <CheckboxSwitch
              isChecked={duplicateCharacter.isAlchemist}
              label={`${duplicateCharacter.name} ${i18next.t('alchemy.isAlchemisteEdit')}`}
              update={(val) => {
                duplicateCharacter.isAlchemist = val;
                if(val && !duplicateCharacter.alchemy) duplicateCharacter.alchemy = alchemy;
                setDuplicateCharacter({...duplicateCharacter});
              }}
            />
            <CheckboxSwitch
              isChecked={duplicateCharacter.isMage}
              label={`${duplicateCharacter.name} ${i18next.t('mage.isMageEdit')}`}
              update={(val) => {
                duplicateCharacter.isMage = val;
                if(val && !duplicateCharacter.magicCards) duplicateCharacter.magicCards = cards;
                setDuplicateCharacter({...duplicateCharacter});
              }}
            />
            <CheckboxSwitch
              isChecked={duplicateCharacter.isDeathMage}
              label={`${duplicateCharacter.name} ${i18next.t('deathMagic.isDeathMageEdit')}`}
              update={(val) => {
                duplicateCharacter.isDeathMage = val;
                if(val && !duplicateCharacter.skills.filter(s => s.label === 'deathMagic').length) {
                  duplicateCharacter.skills.push({ isCustom: false, label: "deathMagic", value: 0, isSpecial: true });
                }
                if(!val && duplicateCharacter.skills.filter(s => s.label === 'deathMagic').length === 1) {
                  duplicateCharacter.skills.splice(duplicateCharacter.skills.findIndex(s => s.label === "deathMagic"), 1);
                }
                setDuplicateCharacter({...duplicateCharacter});
              }}
            />
          </div>
          <div className="editCritThresholds">
            <div className="editCritRow">
              <label className="editCritLabel editCritSuccess">⭐ Critique succès ≤</label>
              <input
                type="number"
                className="editCritInput"
                min={1}
                max={50}
                value={duplicateCharacter.critSuccess ?? 10}
                onChange={(e) => {
                  duplicateCharacter.critSuccess = parseInt(e.target.value, 10);
                  setDuplicateCharacter({...duplicateCharacter});
                }}
              />
            </div>
            <div className="editCritRow">
              <label className="editCritLabel editCritFail">💀 Critique échec ≥</label>
              <input
                type="number"
                className="editCritInput"
                min={50}
                max={99}
                value={duplicateCharacter.critFail ?? 90}
                onChange={(e) => {
                  duplicateCharacter.critFail = parseInt(e.target.value, 10);
                  setDuplicateCharacter({...duplicateCharacter});
                }}
              />
            </div>
            {((duplicateCharacter.critSuccess ?? 10) !== 10 || (duplicateCharacter.critFail ?? 90) !== 90) && (
              <button
                type="button"
                className="editCritReset"
                onClick={() => {
                  duplicateCharacter.critSuccess = 10;
                  duplicateCharacter.critFail = 90;
                  setDuplicateCharacter({...duplicateCharacter});
                }}
              >
                Remettre les valeurs par défaut (10 / 90)
              </button>
            )}
          </div>
        </EditCard>

        <EditCard title={i18next.t('characteristic')}>
          <div className='editCharacGrid'>

            {duplicateCharacter.characteristics && duplicateCharacter.characteristics.map((charac, i) => (
              <div key={i} className='editCharacItem'>
                <span className='editCharacLabel'>{i18next.t(`characteristics.${charac.label}`)}</span>
                <input
                  type='number' min={1} max={99}
                  className='editCharacInput'
                  value={charac.value}
                  onChange={(e) => {
                    duplicateCharacter.characteristics[i].value = parseInt(e.target.value) || 0;
                    setDuplicateCharacter({...duplicateCharacter});
                  }}
                />
              </div>
            ))}
          </div>
          <p className='editRecalcHint'>{i18next.t('recalc skills hint')}</p>
          <button
            type='button'
            className='editRecalcBtn'
            onClick={(e) => { e.preventDefault(); setConfirmRecalcOpen(true); }}
          >
            ↻ {i18next.t('recalc skills')}
          </button>
        </EditCard>

        <EditCard title={i18next.t('skill')}>
          <div className='containerEditSkill'>
            {duplicateCharacter.skills.map((skill, i) => (
              <div key={i} className='editSkillRow'>
                <label>
                  {skill.isCustom
                    ? <input
                        name="skill name" type="text" className='editNameSkill'
                        placeholder={i18next.t('name of skill')}
                        value={skill.label}
                        onChange={(e) => {
                          duplicateCharacter.skills[i].label = e.target.value;
                          setDuplicateCharacter({...duplicateCharacter});
                        }}
                      />
                    : <span className='labelSkillUneditable'>{i18next.t(`skills.${skill.label}`)}</span>
                  }
                  <button
                    type="button"
                    className={`editSkillNoteBtn${openSkillNoteIndex === i ? ' active' : ''}${skill.note ? ' hasNote' : ''}`}
                    onClick={() => setOpenSkillNoteIndex(openSkillNoteIndex === i ? null : i)}
                  >
                    <AnnotationIcon style={{ width: 14, height: 14 }} />
                  </button>
                  <input
                    name="skill value" type="number" min={0} max={100} className='editValueSkill'
                    placeholder={i18next.t('value of skill')}
                    value={skill.value}
                    onChange={(e) => {
                      duplicateCharacter.skills[i].value = parseInt(e.target.value);
                      setDuplicateCharacter({...duplicateCharacter});
                    }}
                  />
                </label>
                {openSkillNoteIndex === i && (
                  <input
                    type="text"
                    className='editSkillNote'
                    placeholder={i18next.t('note')}
                    value={skill.note || ''}
                    autoFocus
                    onChange={(e) => {
                      duplicateCharacter.skills[i].note = e.target.value;
                      setDuplicateCharacter({...duplicateCharacter});
                    }}
                  />
                )}
              </div>
            ))}
            <button
              className='outline editAddSkillBtn'
              onClick={(e) => {
                duplicateCharacter.skills.push({ isCustom: true, label: '', value: '' });
                setDuplicateCharacter({...duplicateCharacter});
                e.preventDefault();
              }}
            >
              {i18next.t('create skill')}
            </button>
          </div>
        </EditCard>

        {user.uid === campaign.idUserDm && (
          <EditCard title={i18next.t('management')}>
            <form
              className='formAssign'
              onSubmit={async (e) => {
                e.preventDefault();
                if(newUserEmail !== '' && newUserEmail) setNewUser();
                else toast.error(i18next.t('assignUser.noEmail'), {});
              }}
            >
              <span className='assignInfo'>{i18next.t('assignUser.title')}</span>
              <div className='titleAssign'>
                <input
                  name="email new user" type="text"
                  placeholder={i18next.t('assignUser.placeholderEmail')}
                  value={newUserEmail || ''}
                  onChange={(e) => setNewUserEmail(e.target.value.trim())}
                />
                <input type="submit" className='outline' value={i18next.t('assignUser.assign')} />
              </div>
            </form>
            <button
              className='danger'
              onClick={(e) => { setConfirmArchiveOpen(true); e.preventDefault(); }}
            >
              {i18next.t('archive.character')}
            </button>
          </EditCard>
        )}

      </form>

      <ConfirmModal
        isOpen={confirmRecalcOpen}
        message={i18next.t('recalc skills confirm')}
        onConfirm={() => { recalcSkillsFromCharacs(); setConfirmRecalcOpen(false); }}
        onCancel={() => setConfirmRecalcOpen(false)}
      />
      <ConfirmModal
        isOpen={confirmArchiveOpen}
        message={i18next.t('archive.character-validation')}
        onConfirm={() => {
          duplicateCharacter.active = false;
          props.updateDataCharacter(duplicateCharacter);
          toast.success(i18next.t('archive.succed'), {});
          setConfirmArchiveOpen(false);
        }}
        onCancel={() => setConfirmArchiveOpen(false)}
      />
    </div>
  );
};

export default EditCharacter;
